"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVehicleOrderDraftQuery = exports.getVehicleOrderQuery = exports.getVehicleOrderStatusQuery = exports.getVehicleOrderAttachmentsQuery = void 0;
const types_1 = require("../../types");
exports.getVehicleOrderAttachmentsQuery = `
  query getVehicleOrderAttachments($vehicleOrderId: String!) {
    getVehicleOrderAttachments(vehicleOrderId: $vehicleOrderId) {
      ...attachment
    }
  }
  ${types_1.attachmentFragment}
`;
exports.getVehicleOrderStatusQuery = `
  query findVehicleOrderStatusById($vehicleOrderId: String, $id: String, $status: String) {
    findVehicleOrderStatusById(vehicleOrderId: $vehicleOrderId, id: $id, status: $status) {
      ...orderStatus
    }
  }
${types_1.vehicleOrderStatusFragment}
`;
exports.getVehicleOrderQuery = `
  query getVehicleOrder($orderId: String!) {
    getVehicleOrder(orderId: $orderId) {
      ...bosOrder   
    }
  }
${types_1.bosOrderFragment}
`;
exports.getVehicleOrderDraftQuery = `
  query getVehicleOrderDraft($orderId: String!) {
    getVehicleOrderDraft(orderId: $orderId) {
      ...bosVehicleOrderDraft   
    }
  }
  ${types_1.bosVehicleOrderDraft}
`;
//# sourceMappingURL=vehicle-order.js.map